import pages from 'services/routes/pages';
import * as pathConstant from 'services/routes/constants';

// MMM sidebar menu (independent of ad / all-traffic tab menus)
const mmmNavConfig = {
  screenId: pathConstant.MMM_EBIS,
  title: pages[pathConstant.MMM_EBIS].key,
  iconClass: 'far fa-chart-line',
  svg: 'mmm_ebis',
  url: pathConstant.HYPERLINK_HASH,
  type: pathConstant.INTERNAL,
  newTab: false,
  submenu: [
    {
      screenId: pathConstant.MMM_ANALYSIS_SETTINGS,
      title: pages[pathConstant.MMM_ANALYSIS_SETTINGS].key,
      iconClass: 'far fa-arrow-right',
      url: pages[pathConstant.MMM_ANALYSIS_SETTINGS].path,
      type: pathConstant.INTERNAL,
      newTab: false,
    },
    {
      screenId: pathConstant.MMM_OPTIMIZATION_RESULTS,
      title: pages[pathConstant.MMM_OPTIMIZATION_RESULTS].key,
      iconClass: 'far fa-arrow-right',
      url: pages[pathConstant.MMM_OPTIMIZATION_RESULTS].path,
      type: pathConstant.INTERNAL,
      newTab: false,
    },
  ],
};

export default mmmNavConfig;
